import noChatBG from "../../../Assets/Images/noChatBG.png";

export default function HelpCenter() {
  return (
    <main
      className="w-full h-full bg-cover bg-center px-10 pb-10 pt-5 overflow-y-auto bg-[#f9f6fe] dark:bg-[#0b0c15]"
      style={{
        // backgroundImage: `url(${noChatBG})`,
      }}
    >
      <div className="prose mx-auto max-w-4xl dark:prose-invert">
        <h1 className="text-center pb-3 dark:text-white">Help Center</h1>
        <div className="mx-auto">

          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-2">1. How do I create an account?</h2>
            <p>
              Simply download the app from the App Store or Google Play. Open the app, enter your phone number, and follow the verification steps to set up your profile.
            </p>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-2">2. Do I need to verify my number?</h2>
            <p>
              Yes, for security and to prevent spam, we require phone number verification using an OTP (One-Time Password).
            </p>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-2">3. Are my messages private?</h2>
            <p>
              Yes. All your messages are protected with end-to-end encryption. This means only you and your recipient can read them — not even we can access them.
            </p>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-2">4. Can I delete a message?</h2>
            <p>
              Yes. Tap and hold the message you want to delete. You’ll have the option to delete for yourself or for everyone (within a time limit).
            </p>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-2">5. Can I send files or media?</h2>
            <p>
              Absolutely! You can share images, videos, documents, and voice notes securely within your chats.
            </p>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-2">6. Is my contact list uploaded?</h2>
            <p>
              We access your contacts only to show who’s on JNTO. We never store your contact list on our servers.
            </p>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-2">7. How secure is JNTO?</h2>
            <p>
              We use industry-standard end-to-end encryption, device-level protection, and do not sell or share your data.
            </p>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-2">8. Why can’t I send or receive messages?</h2>
            <p>
              Check your internet connection. If it’s strong, try restarting the app or your device. Still having trouble? Reach out to our support team.
            </p>
          </div>

          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-2">9. How do I update my profile info?</h2>
            <p>
              Go to the Profile tab and tap Edit to change your name, photo, or status message.
            </p>
          </div>

        </div>
      </div>
    </main>
  );
}
